import { useUpdateUser } from "~/gen/api"
import { showAxiosError } from "~/utils/showAxiosError"
import { showSuccessNotification } from "~/utils/showSuccessNotification"

const NOTIFICATIONS = {
  SUCCESS: {
    autoClose: 10000,
    styles: {
      description: {
        maxHeight: "unset",
        height: "min-content",
        textOverflow: "unset",
      },
    },
    message: `User status updated`,
    color: "green",
  },
  ERROR: {
    title: "Error",
    message: "An error occurred while toggling the user status",
    color: "red",
  },
}

export const useToggleUserActiveStatusMutation = () =>
  useUpdateUser({
    mutation: {
      onSuccess: () => {
        showSuccessNotification(NOTIFICATIONS.SUCCESS)

        return true
      },
      onError: (error) => {
        showAxiosError({
          error,
          showNotification: true,
          defaultMessage: NOTIFICATIONS.ERROR.message,
          notificationTitle: NOTIFICATIONS.ERROR.title,
        })
        return false
      },
    },
  })
